module.exports = __webpack_public_path__ + "img/trash-icon.32b5b620.svg";